import { HttpResponse, delay, http } from 'msw';
import { API, BASE_URL_V2 } from '../../../src/common/constants';
import { generateTourIsolineMock } from '../data/isolineDataMock';
import type { GenerateTourIsolineApiResponse } from '../../../src/store/facade/facadeApiV2';

const REQUEST_DELAY_REALISTIC = undefined;
const TOUR_ISOLINE_URL = `${BASE_URL_V2}${API.endpoints.tour}/:id${API.endpoints.isoline}`;

export const mockedTourIsolineResponse = http.get(TOUR_ISOLINE_URL, async () => {
    await delay(REQUEST_DELAY_REALISTIC);

    return HttpResponse.json<GenerateTourIsolineApiResponse>(generateTourIsolineMock());
});

const tourIsolineEmptyResponse = http.get(TOUR_ISOLINE_URL, () => {
    return HttpResponse.json<GenerateTourIsolineApiResponse>({ coordinates: [] });
});

const tourIsolineErrorResponse = http.get(TOUR_ISOLINE_URL, async () => {
    await delay(REQUEST_DELAY_REALISTIC);

    return HttpResponse.json(null, { status: 500 });
});

export const TourIsolineResponse = {
    success: mockedTourIsolineResponse,
    empty: tourIsolineEmptyResponse,
    error: tourIsolineErrorResponse,
};
